import React from 'react'
import { Collapse } from 'reactstrap'

/**
 * CollapsablePluginFilter
 * @param {Object} props - Component props
 * @param {string} [props.filterKey] - The key to control the filter [optional]
 * @param {React.Component} [props.filterComponent] - Component for filtering [optional] 
 * @param {React.Component} [props.searchComponent] - Component for searching [optional]
 */
export const CollapsablePluginFilter = (props) => {
  const { filterKey, filterComponent, searchComponent } = props
  if (filterComponent || searchComponent) {
    return (
      <Collapse isOpen={filterKey !== ''}>
        {filterKey === 'filter' && filterComponent}
        {filterKey === 'search' && searchComponent}
      </Collapse>
    )
  }
  return null
}

export default CollapsablePluginFilter
